module.exports = __webpack_public_path__ + "static/media/Display.3f94d8ad.svg";